<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="$route.meta.length === 0 || !$route.meta.keepAlive"></router-view>
<!--    <router-view></router-view>-->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

  html, body {
    margin: 0;
    border: 0;
    font-family: "Helvetica-Neue", "Helvetica", Arial, sans-serif;
    line-height: 1.5;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    background-color: #FFF;
    -webkit-user-select: none;

    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue